<template>
 <div :class="windowClass">
      <v-toolbar class="ma-2" dense flat>
        <v-spacer/>
         <v-btn class="ma-1" small @click="print=true"><v-icon left>mdi-printer</v-icon> Print</v-btn>
         <v-btn class="ma-1" small v-if="sales.status=='posted'" @click="sales.status ='on-process',Save()"><v-icon left>mdi-undo</v-icon> Re-Process</v-btn>
        <v-btn class="ma-1" small color="secondary" v-if="sales.status=='on-process'" @click="sales.status ='posted',Save()"><v-icon left>mdi-check</v-icon> POST</v-btn>
        <v-btn class="ma-1" small color="success" v-if="sales.status=='posted'" @click="payform=true"><v-icon left>mdi-check</v-icon> complete</v-btn>
      <v-btn class="ma-1" small color="success" v-if="sales.status=='complete'" @click="sales.status ='void',Save()"><v-icon left>mdi-download-outline</v-icon> void</v-btn>
      </v-toolbar>
        <v-row class="ma-1">
            <v-col cols="4">
                <v-text-field
                  v-model="sales.invoice"
                  label="INVOICE #:"
                  @change="Save()"
                  :disabled="!EDIT"
                  dense
                  outlined
                  filled
                />
                 <v-autocomplete
                  v-model="sales.customer"
                  label="CUSTOMER"
                  :items="$store.state.customers"
                  item-text="trade_name"
                  item-value="id"
                  dense
                  outlined
                  :disabled="!EDIT"
                  filled
                   @change="Save()"
                />
                <v-text-field
                 :value="SELECTCUSTOMER.contact_number"
                  label="CONTACT #:"
                  dense
                  outlined
                    :disabled="true"
                  filled
                />
            </v-col>  
             <v-col cols="4">
                <v-text-field
                  label="DATE"
                  :value="sales.created | moment($date_only)"
                  dense
                  outlined
                  :disabled="true"
                  filled
                />
                 
                <v-text-field
                  :value="SELECTCUSTOMER.address"
                  label="ADDRESS:"
                    :disabled="true"
                  dense
                  outlined
                  filled
                />

               
            </v-col>
            
             <v-col cols="4">
                 <v-autocomplete
                  v-model="sales.payment_type"
                  label="PAYMENT TYPE:"
                  :disabled="!EDIT"
                   @change="Save()"
                  :items="['Cash','Cheque', 'Credit']"
                  dense
                  outlined
                  filled
                />
                  <v-text-field
                  :value="sales.payment_status=='paid'?'Paid':'Unpaid'"
                  label="PAYMENT STATUS:"
                  dense
                  outlined
                  filled
                  :disabled="true"
                />
                 <v-text-field
                  v-model="sales.status"
                  label="STATUS"
                  dense
                  :disabled="true"
                  outlined
                  filled
                  
                />
            </v-col>

             <v-col cols="12">
                <v-card>
                  <v-toolbar dense color="secondary" dark>
                     EMPTIES - DEPOSIT/REFUND
                       <v-spacer/>
                     <v-icon @click="emptyform=true" v-if="sales.status !='delivered'">mdi-plus-box</v-icon>
                  </v-toolbar>
                 
                    <v-data-table
                    class="va-table mt-4"
                    dense
                    :headers="empties_headers"
                    :items="empties"
                    disable-pagination
                    hide-default-footer
                    >
                    <template v-slot:body="{ items }">
                        <tbody>
                        <tr v-for="(item,index) in items" :key="index">
                          <td>{{item.product_code}}</td>
                          <td>{{item.description}}</td>
                          <td class="text-right" width="70">
                            <input 
                              type="number"
                                class="va-input pa-1"
                               v-model="item.refund"
                                :disabled="!EDIT"
                                @change="SaveItem(item)"
                              />
                          </td>
                           <td class="text-right" width="70">
                             <input 
                             class="va-input pa-1"
                              type="number"
                               v-model="item.deposit"
                               :disabled="true"
                              />
                           
                          </td>
                            <td class="text-right">{{$money(($IsNum(item.deposit) - $IsNum(item.refund)) * $IsNum(item.unit_price)  )}}</td>
                        </tr>
                          <tr style="background: #efefef;">
                              <th colspan="4" class="text-right">TOTAL NET DEPOSIT/REFUND</th>
                              <th class="text-right">{{$money(EMTPTIESTOTAL)}}</th>
                          </tr>
                        </tbody>
                    </template>
                </v-data-table>
                 
                </v-card>
             </v-col>

              <v-col cols="12">
                <v-card>
                  <v-toolbar dense color="secondary" dark>
                     FULL CONTENTS
                     <v-spacer/>
                     <v-icon @click="fullform=true" v-if="EDIT">mdi-plus-box</v-icon>
                  </v-toolbar>
                 
                       <v-data-table
                    class="va-table"
                    dense
                    :headers="full_headers"
                    :items="fulls"
                    disable-pagination
                    hide-default-footer
                    >
                    <template v-slot:body="{ items }">
                        <tbody>
                        <tr v-for="(item,index) in items" :key="index">
                          <td><v-icon v-if="EDIT" small left color="error" @click="RemoveFullItem(item)">mdi-delete</v-icon> {{item.product_code}}</td>
                          <td>{{item.description}}</td>
                           <td class="text-right">{{item.quantity}}</td>
                              <td class="text-right">{{$money(item.unit_price)}}</td>
                          <td class="text-right">{{$money($IsNum(item.unit_price) * $IsNum(item.quantity) )}}</td>
                        </tr>
                         <tr style="background: #efefef;">
                              <th colspan="4" class="text-right">TOTAL GROSS VALUE SOLD</th>
                              <th class="text-right">{{$money(GROSSTOTAL)}}</th>
                          </tr>
                        </tbody>
                    </template>
                </v-data-table>
                 
                </v-card>
             </v-col>

             <v-col cols="12">
                <v-card>
                  <v-toolbar dense color="secondary" dark>
                    DISCOUNTS
                     <v-spacer/>
                     <!-- <v-icon @click="discountform=true" v-if="EDIT">mdi-plus-box</v-icon> -->
                  </v-toolbar>
                 
                       <v-data-table
                    class="va-table"
                    dense
                    :headers="discount_headers"
                    :items="DISCOUNTS"
                    disable-pagination
                    hide-default-footer
                    >
                    <template v-slot:body="{ items }">
                        <tbody>
                        <tr v-for="(item,index) in items" :key="index">
                          <td><v-icon v-if="EDIT" small left color="error" @click="RemoveDiscountItem(index)">mdi-delete</v-icon> {{item.description}}</td>
                          
                          <td class="text-right">{{$money(item.amount)}}</td>
                        </tr>
                         <tr style="background: #efefef;">
                              <th class="text-right">LESS DISCOUNTS</th>
                              <th class="text-right">{{$money(DISCOUNTTOTAL)}}</th>
                          </tr>
                        </tbody>
                    </template>
                </v-data-table>
                 
                </v-card>
             </v-col>


             <v-col cols="6">
                <v-card>
                  <v-toolbar dense color="secondary" dark>
                     REDEEMED EMPTIES
                    <v-spacer/>
                       <v-icon @click="form2=true" v-if="EDIT">mdi-plus-box</v-icon>
                  </v-toolbar>
                       <v-data-table
                    class="va-table"
                    dense
                    :headers="redeem_headers"
                    :items="redeemed_items"
                    disable-sort
                    hide-default-footer
                    >
                    <template v-slot:body="{ items }">
                        <tbody>
                        <tr v-for="(item,index) in items" :key="index">
                           <td>{{item.product}}</td>
                            <td>{{item.quantity}}</td>
                            <td class="text-right">{{$money(item.amount)}}</td>
                        </tr>
                          <tr style="background: #efefef;">
                              <th colspan="2" class="text-right">TOTAL REDEEMED</th>
                              <th class="text-right">{{$money(REDEEMEDTOTAL)}}</th>
                          </tr>
                        </tbody>
                    </template>
                </v-data-table>
                 
                </v-card>
             </v-col>

             <v-col cols="6">
                <v-card>
                  <v-toolbar dense color="secondary" dark>
                      BORROWED EMPTIES
                     <v-spacer/>
                       <v-icon @click="borrowform=true" v-if="EDIT">mdi-plus-box</v-icon>
                  </v-toolbar>
                 
                       <v-data-table
                    class="va-table"
                    dense
                    :headers="borrowheaders"
                    :items="borrowed_items"
                    disable-sort
                    hide-default-footer
                    >
                    <template v-slot:body="{ items }">
                        <tbody>
                        <tr v-for="(item,index) in items" :key="index">
                          <td :class="STATUS_TEXT(item.type)">{{item.type}}</td>
                          <td>{{item.product_code}}</td>
                            <td>{{item.quantity}}</td>
                            <td class="text-right">{{$money(item.amount)}}</td>
                        </tr>
                        <tr style="background: #efefef;">
                              <td  class="text-right">BORROWED</td>
                              <td class="text-right">{{$money(BORROWEDTOTAL)}}</td>
                              <td  class="text-right">RETURN BORROWED</td>
                              <td class="text-right">{{$money(RETURNBORROWEDTOTAL)}}</td>
                          </tr>
                        </tbody>
                    </template>
                </v-data-table>
                 
                </v-card>
             </v-col>

             <v-col cols="12">
                <v-card>
                      <table class="va-table md-font" width="100%">
                          <tr style="background: #efefef;">
                            <th class="text-left pa-2">TOTAL NET VALUE SOLD - CONTENTS</th>
                            <th class="text-right pa-2">{{$money(GROSSTOTAL)}}</th>
                          </tr>
                           <tr style="background: #efefef;">
                            <th class="text-left pa-2">TOTAL NET DEPOSIT/REFUND</th>
                            <th class="text-right pa-2">{{$money(EMTPTIESTOTAL)}}</th>
                          </tr>
                          <tr style="background: #efefef;">
                            <th class="text-left pa-2">TOTAL RETURN BORROWED - EMPTIES</th>
                            <th class="text-right pa-2">{{$money(RETURNBORROWEDTOTAL)}}</th>
                          </tr>
                           <tr style="background: #efefef;">
                            <th class="text-left pa-2">LESS DISCOUNTS</th>
                            <th class="text-right pa-2">{{$money(DISCOUNTTOTAL)}}</th>
                          </tr>
                          <tr style="background: #efefef;">
                            <th class="text-left pa-2">TOTAL BORROWED - EMPTIES</th>
                            <th class="text-right pa-2">{{$money(BORROWEDTOTAL)}}</th>
                          </tr>
                          <tr style="background: #efefef;">
                            <th class="text-left pa-2">TOTAL REDEEMED - EMPTIES</th>
                            <th class="text-right pa-2">{{$money(REDEEMEDTOTAL)}}</th>
                          </tr>
                            <tr style="background: #efefef;">
                            <th class="text-left pa-2">GRAND TOTAL - VALUE OF GOODS SOLD</th>
                            <th class="text-right pa-2">{{$money(GRANDTOTAL)}}</th>
                          </tr>
                      </table>
                 
                </v-card>
             </v-col>
        </v-row>
     <va-full-form :show="fullform" :customer="sales.customer" method="sales" :itemid="parseInt(this.$route.params.id)" @DialogEvent="fullEvent"/>
      <va-borrowed-form :show="borrowform" method="sales" :sales="this.sales" @DialogEvent="fullEvent"/>
     <va-keep-items :show="form2" method="sales" :keep="{customer:sales.customer}" @DialogEvent="bEvent"/>
     <va-payment-form :show="payform" :summary="SUMMARY" :total="GRANDTOTAL" @DialogEvent="payEvent"/>
      <va-discount-form :show="discountform" @DialogEvent="discountEvent"/>
     <print-sales :show="print" :sales="sales" :summary="SUMMARY" :empties="empties" :fulls="fulls" :redeemeds="redeemed_items" :borroweds="borrowed_items" :customer="SELECTCUSTOMER" @DialogEvent="printEvent"/>
     <va-empty-form :show="emptyform"  method="sales" :itemid="parseInt(this.$route.params.id)" @DialogEvent="fullEvent"/>
  </div>
</template>
<script>
import { API_MIXINS } from '@/mixins/api_mixins.js'
import {
  mapMutations
} from 'vuex'
  export default {
    mixins: [API_MIXINS],
    data: () => ({
      print: false,
      emptyform: false,
      payform: false,
      discountform: false,
       borrowform: false,
        fullform: false,
        form2: false,
        empties_headers: [
        { text: 'CODE', value: 'product_code', sortable: false},
        { text: 'DESC', value: 'description', sortable: false},
        { text: 'REFUND', align: 'center', value: 'refund', sortable: false},
        { text: 'DEPOSIT', align: 'center', value: 'deposit', sortable: false},
        { text: 'AMOUNT',  align: 'right',sortable: false },
         ],
         full_headers: [
        { text: 'CODE', value: 'product_code', sortable: false},
        { text: 'DESC', value: 'description', sortable: false},
        { text: 'QTY', value: 'quantity', align: 'right', sortable: false},
        { text: 'UNIT PRICE', align: 'right', value: 'unit_price', sortable: false},
        { text: 'AMOUNT',  align: 'right',sortable: false },
         ],

          discount_headers: [
          { text: 'DESC', value: 'description', sortable: false},
          { text: 'AMOUNT',  align: 'right',sortable: false },
         ],
          redeem_headers:[
            { text: 'CODE'},
            { text: 'QTY' },
            { text: 'AMOUNT',  align: 'right'},
        ],
       borrowheaders:[
          { text: 'TYPE'},
            { text: 'CODE'},
            { text: 'QTY'},
            { text: 'AMOUNT',  align: 'right'},
        ],
        DiscountTypes: ["Trade Deals", "Pick-up Discount", "Cash Discount", "Other"],
        SalesID:0,
        sales:{},
        empties: [],
        discounts:[],
        fulls: [],
        redeemed_items:[],
        borrowed_items:[]
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.setLoggedIn(true) 
          this.SET_MENUS()
          this.GET_CUSTOMERS('active')
           this.GET_PRODUCTS()
           this.GET_SUPPLIERS()
           this.GET_AVAILABLES()
           this.GET_SETTINGS()
          this.SalesID = parseInt(this.$route.params.id)
          this.getSales()
          
        }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
      EDIT() {
        if(this.sales.status=='on-process'){
            return true
        }
        return false
      },
      SELECTCUSTOMER() {
           var arr = this.$store.state.customers.reduce((res, item)=>{
            if(item.id==this.sales.customer) {
             res = item
            }
            return res
        },{})
        return arr
      },
      TRUCK() {
         if(this.$store.state.trucks == undefined || this.$store.state.trucks == null) {
          return []
        }
        var arr = this.$store.state.trucks.reduce((res, item)=>{
            if(item.id==this.sales.truck) {
             res = item
            }
            return res
        },{})
        return arr
      },
      CONTAINERS(){
        var arr =  this.$store.state.products.reduce((res, item)=>{
            if(item.type=="empties"  && item.sort>0) {
                res.push(item)
            }
            return res
        },[])
        return arr
      },
      DISCOUNTS() {
        return this.sales.Discounts != null?this.sales.Discounts:[]
      },
      EMTPTIESTOTAL() {
        var total =  this.empties.reduce((res, item)=>res += (this.$IsNum(item.deposit) - this.$IsNum(item.refund)) * this.$IsNum(item.unit_price),0)
        return total
      },
      GROSSTOTAL() {
        var total =  this.fulls.reduce((res, item)=>res += this.$IsNum(item.quantity)* this.$IsNum(item.unit_price),0)
        return total
      },
      DISCOUNTTOTAL:function(){
        var total =  this.DISCOUNTS.reduce((res, item)=>res += this.$IsNum(item.amount),0)
        return total
      },
      REDEEMEDTOTAL() {
          var total =  this.redeemed_items.reduce((res, item)=>res += this.$IsNum(item.amount),0)
          return total
      },
      RETURNBORROWEDTOTAL() {
          var total =  this.borrowed_items.reduce((res, item)=>{
            if(item.type=='Returned') {
              res += this.$IsNum(item.amount)
            }
            return res
          },0)
          return total
      },
      BORROWEDTOTAL() {
          var total =  this.borrowed_items.reduce((res, item)=>{
            if(item.type=='Borrowed') {
              res += this.$IsNum(item.amount)
            }
            return res
          },0)
          return total
      },
      GRANDTOTAL(){
          return this.GROSSTOTAL + this.EMTPTIESTOTAL + this.RETURNBORROWEDTOTAL - this.DISCOUNTTOTAL - this.REDEEMEDTOTAL - this.BORROWEDTOTAL
      },
      SUMMARY(){
        return [
          {description:"TOTAL NET VALUE SOLD - CONTENTS", amount: this.GROSSTOTAL, total: 'gross_total'},
           {description:"TOTAL RETURN BORROWED - EMPTIES", amount: this.RETURNBORROWEDTOTAL, total: 'return_borrowed_total'},
          {description:"TOTAL BORROWED - EMPTIES", amount: this.BORROWEDTOTAL, total: 'borrowed_total'},
          {description:"TOTAL REDEEMED - EMPTIES", amount: this.REDEEMEDTOTAL, total: 'redeemed_total'},
          {description:"GRAND TOTAL - VALUE OF GOODS SOLD", amount: this.GRANDTOTAL, total: 'grand_total'},
        ]
      }
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
      discountEvent(data) {
        this.discountform = false
        if("close" != data) {
          this.addDiscount(data)
        }
      },
      addDiscount(discount){ 
        this.sales.Discounts == null?this.sales.Discounts = [discount]:this.sales.Discounts.push(discount)
        this.Save()
      },
      RemoveDiscountItem(index){
        this.sales.Discounts.splice(index,1)
        this.Save()
      },
      printEvent(){
        this.print = false
      },
     payEvent(data){
       this.payform=false
       if(data != 'close') {
          this.sales.payment_status = 'Paid'
            this.sales.payment_type = data.type
            this.sales.cash_amount = data.cash_amount
            if(data.type == 'Cheque') {
              this.sales.bank = data.bank
              this.sales.cheque_no = data.cheque_no
              this.sales.cheque_amount = data.cheque_amount
            }
             if(data.type == 'Credit') {
                this.sales.payment_status = 'Unpaid'
              }
            this.sales.status = 'delivered'
            
            this.Save()
       }
     },
      fullEvent() {
        this.fullform = false
        this.borrowform = false
        this.emptyform = false
         setTimeout(() => {
            this.GET_AVAILABLES()
              this.getSales()
            }, 300);
      },
      bEvent(data){
        this.form2 = false
          if(data != 'close') {
              this.redeemedItem(data)
              
          }
      },
      redeemedItem(item){
          var param = {
              invoice_no:this.sales.invoice,
              quantity: this.$IsNum(item.available),
              safekeep_id:  this.$IsNum(item.id)
          }
         console.log(param)
          this.$http.post("keep/redeemed_item", param).then(response => {
              this.GET_RESPONSE(response)
               this.getSales()
          }).catch(e => {
           console.log(e.data)
         })
      },
      getSales() {
        this.$http.post("sales/view", {id:this.SalesID}).then(response => {
            response.data.sales != null?this.sales = response.data.sales:this.sales={}
            response.data.empties != null?this.empties = response.data.empties:this.empties=[]
            response.data.fulls != null?this.fulls = response.data.fulls:this.fulls=[]
            response.data.redeemeds != null?this.redeemed_items = response.data.redeemeds:this.redeemed_items=[]
            response.data.borroweds != null?this.borrowed_items = response.data.borroweds:this.borrowed_items=[]
          }).catch(e => {
           console.log(e.data)
         })
      },
       Save() {
         this.sales.amount = this.GRANDTOTAL.toString()
        this.$http.post("sales/update", this.sales).then(response => {
             this.GET_RESPONSE(response)
          }).catch(e => {
           console.log(e.data)
         })
      },
      SaveItem(item) {
        item.refund = this.$IsNum(item.refund)
        item.deposit = this.$IsNum(item.deposit)
        console.log(item)
        this.$http.post("sales/save_item", item).then(response => {
              this.GET_RESPONSE(response)
           this.getSales()
         }).catch(e => {
           console.log(e.data)
         })
      },
      RemoveFullItem(item) {
        this.$http.post("sales/remove_item", item).then(response => {
              response.data.status?this.VA_ALERT("success", response.data.message):this.VA_ALERT("error", response.data.message)
            setTimeout(() => {
              this.getSales()
            }, 500);
            
         }).catch(e => {
           console.log(e.data)
         })
      }
    },
  }
</script>